import React, { useState, useEffect } from 'react';
import './index.css';
import uploadImg from '../../../images/upload.png';
import {
  Container,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  ModalBody,
  Modal,
} from 'reactstrap';
import { NumericFormat } from 'react-number-format';
import { useNavigate, useLocation } from 'react-router-dom';
import { editDealer, dealerDocumentUpload } from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import moment from 'moment';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import previewImg from '../../../images/previewImg.png';
import closeImg from '../../../assets/img/close.png';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { CommonButton } from '../../../Components/CommonComponents';
import UploadDocPreview from '../../../Components/CustomModal/UploadDocPreview/UploadDocPreview';
import { handleErrorMessage } from '../../../utils/utils';
import { UploadModal } from '../../../Components/CustomModal';
import { messages } from '../../../utils/constant-messages';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
import DateService from '../../../services/DateService';
import { dateFormat } from '../../../constants/dateFormat';

const AdvanceBusinessDetails = () => {
  const navigate = useNavigate();
  const [currentRadioValue, setCurrentValue] = useState('');
  const [currentapplicableVal, setCurrentapplicableVal] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [chequeSelection, setChequeSelection] = useState('');
  const [isDistributor, setIsDistributor] = useState('');
  const [previewImgModal, setPreviewImgModal] = useState(false);
  const [popupImgPreview, setPopupImgPreview] = useState('');
  const [title, setTitle] = useState('');
  const [businessTitle, setBusinessTitle] = useState({});
  const [imageKey, setImageKey] = useState('');
  const [isKycRequired, setIsKycRequired] = useState(false);
  const initialValues = {
    bankName: null,
    accountNumber: null,
    adharNumber: null,
    ifscNeftRtgsCode: null,
    authorityBankName: null,
    gstNumber: null,
    panNumber: null,
    shopActNumber: null,
    pesticideLicenseNumber: null,
    licenseValidDate: null,
    wholeSaleLicenseNumber: null,
    pesticideLicenseValidDate: null,
    gstDocUpload: null,
    partnershipUpload: null,
    pesticideLicenseUpload: null,
    adharUpload: null,
    panUpload: null,
    wholsaleFetilizersLicenseUpload: null,
    shopActDocumentUpload: null,
    neftRtgsRefNo: null,
    brnachName: null,
    cCLimit: null,
    branchAddress: null,
    neftRtgsDate: null,
    amount: null,
    cheque: null,
    chequeDate: null,
    modeOfPayment: null,
    seedsLicenseValidDate: null,
    chequeBankName: null,
    seedsLicenseNumber: null,
    seedsLicenseUpload: null,
    neftRtgsUpload: null,
    firmPanNumber: null,
    chequeUpload: null,
    securityBankName: null,
    chequeOneNumber: null,
    chequeTwoNumber: null,
  };
  const [formValues, setFormValues] = useState(initialValues);

  const [docKey, setDocKey] = useState(null);

  const [isModalLoading, setIsModalLoading] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);

  const [checkImg, setCheckImg] = useState([]);
  const [checkBinaryImg, setCheckBinaryImg] = useState([]);
  const [checkPreview, setCheckPreview] = useState([]);

  const [neftImg, setNeftImg] = useState([]);
  const [neftBinaryImg, setNeftBinaryImg] = useState([]);
  const [neftPreview, setNeftPreview] = useState([]);

  const [check1Img, setCheck1Img] = useState([]);
  const [check1BinaryImg, setCheck1BinaryImg] = useState([]);
  const [check1Preview, setCheck1Preview] = useState([]);

  const [check2Img, setCheck2Img] = useState([]);
  const [check2BinaryImg, setCheck2BinaryImg] = useState([]);
  const [check2Preview, setCheck2Preview] = useState([]);

  const [shopImg, setShopImg] = useState([]);
  const [shopBinaryImg, setShopBinaryImg] = useState([]);
  const [shopPreview, setShopPreview] = useState('');

  const [gstImg, setGstImg] = useState([]);
  const [gstBinaryImg, setGstBinaryImg] = useState([]);
  const [gstPreview, setGstPreview] = useState('');

  const [panFirmImg, setPanFirmImg] = useState([]);
  const [panFirmBinaryImg, setPanFirmBinaryImg] = useState([]);
  const [panFirmPreview, setPanFirmPreview] = useState('');

  const [adharImg, setAdharImg] = useState([]);
  const [adharBinaryImg, setAdharBinaryImg] = useState([]);
  const [adharPreview, setAdharPreview] = useState('');

  const [panOwnerImg, setPanOwnerImg] = useState([]);
  const [panOwnerBinaryImg, setPanOwnerBinaryImg] = useState([]);
  const [panOwnerPreview, setPanOwnerPreview] = useState('');

  const [fertilizeImg, setFertilizeImg] = useState([]);
  const [fertilizeBinaryImg, setFertilizeBinaryImg] = useState([]);
  const [fertilizePreview, setFertilizePreview] = useState('');

  const [pesticidesImg, setPesticidesImg] = useState([]);
  const [pesticidesBinaryImg, setPesticidesBinaryImg] = useState([]);
  const [pesticidesPreview, setPesticidesPreview] = useState('');

  const [returnItImg, setReturnItImg] = useState([]);
  const [returnItBinaryImg, setReturnItBinaryImg] = useState([]);
  const [returnItPreview, setReturnItPreview] = useState('');

  const [bankStImg, setBankStImg] = useState([]);
  const [bankStBinaryImg, setBankStBinaryImg] = useState([]);
  const [bankStPreview, setBankStPreview] = useState('');

  const [prShipDeedImg, setPrShipDeedImg] = useState([]);
  const [prShipDeedBinaryImg, setPrShipDeedBinaryImg] = useState([]);
  const [prShipDeedPreview, setPrShipDeedPreview] = useState('');

  let location = useLocation();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const dispatch = useDispatch();
  const { dealerObj } = useSelector((state) => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    if (dealerObj.business_type === 'Partnership Firm') {
      setIsDistributor(dealerObj.business_type);
    } else if (dealerObj.business_type === 'Pvt.ltd.') {
      setIsDistributor(dealerObj.business_type);
    } else if (dealerObj.business_type === 'Ltd.') {
      setIsDistributor(dealerObj.business_type);
    }
    setFormValues({
      bankName: dealerObj.bank_name,
      authorityBankName: dealerObj.sigining_authority_person_name,
      accountNumber: dealerObj.account_number,
      ifscNeftRtgsCode: dealerObj.ifsc_code,
      shopActNumber: dealerObj.shop_act_no,
      gstNumber: dealerObj.gst_no,
      panNumber: dealerObj.pan_no,
      wholeSaleLicenseNumber: dealerObj.fertilizer_lic_no,
      gstDocUpload: dealerObj.gst_no_file,
      licenseValidDate: dealerObj && dealerObj.fertilizer_lic_valid_date ? DateService.utcToLocalDateOnly(dealerObj.fertilizer_lic_valid_date, dateFormat.DATE_FORMAT_4) : "",
      adharNumber: dealerObj.aadhar_no,
      pesticideLicenseNumber: dealerObj.pesticides_lic_no,
      pesticideLicenseValidDate: dealerObj && dealerObj.pesticides_lic_valid_date ? DateService.utcToLocalDateOnly(dealerObj.pesticides_lic_valid_date, dateFormat.DATE_FORMAT_4) : "",
      panUpload: dealerObj.pan_no_file,
      adharUpload: dealerObj.aadhar_no_file,
      shopActDocumentUpload: dealerObj.shop_act_no_file,
      partnershipUpload: dealerObj.partnership_deed_file,
      wholsaleFetilizersLicenseUpload: dealerObj.fertilizer_lic_no_file,
      pesticideLicenseUpload: dealerObj.pesticides_lic_no_file,
      branchAddress: dealerObj.bank_address,
      cCLimit: dealerObj.bank_limit,
      chequeBankName: dealerObj.cheque_bank_name,
      chequeDate: dealerObj && dealerObj.cheque_date ? DateService.utcToLocalDateOnly(dealerObj.cheque_date, dateFormat.DATE_FORMAT_4) : "",
      cheque: dealerObj.cheque_number,
      neftRtgsUpload: dealerObj.neft_rtgs_reciept,
      chequeUpload: dealerObj.cheque_image,
      modeOfPayment: dealerObj.payment_mode,
      amount: dealerObj.security_deposit,
      seedsLicenseUpload: null,
      seedsLicenseValidDate: dealerObj && dealerObj.seeds_license_date ? DateService.utcToLocalDateOnly(dealerObj.seeds_license_date, dateFormat.DATE_FORMAT_4) : "",
      seedsLicenseNumber: dealerObj.seeds_license_number,
      brnachName: dealerObj.branch_name,
      neftRtgsRefNo: dealerObj.neft_rtgs_ref_number,
      neftRtgsDate: dealerObj && dealerObj.neft_rtgs_date ? DateService.utcToLocalDateOnly(dealerObj.neft_rtgs_date, dateFormat.DATE_FORMAT_4) : "",
      firmPanNumber: dealerObj.firm_pan_no,
      firmPanUpload: dealerObj.firm_pan_file,
      chequeOneNumber: dealerObj.cheque_number_1,
      chequeTwoNumber: dealerObj.cheque_number_2,
      securityBankName: dealerObj.security_bank_name,
    });
    setGstPreview(dealerObj.gst_no_file);
    setShopPreview(dealerObj.shop_act_no_file);
    setPanOwnerPreview(dealerObj.pan_no_file);
    setPanFirmPreview(dealerObj.firm_pan_file);
    setAdharPreview(dealerObj.aadhar_no_file);
    setNeftPreview(dealerObj.neft_rtgs_reciept);
    setFertilizePreview(dealerObj.fertilizer_lic_no_file);
    setPesticidesPreview(dealerObj.pesticides_lic_no_file);
    setReturnItPreview(dealerObj.it_return_file);
    setBankStPreview(dealerObj.last_six_month_bank_statement);
    setPrShipDeedPreview(dealerObj.partnership_deed_file);
    setCheckPreview(dealerObj.cheque_image);
    setCheck1Preview(dealerObj.cheque_1_image);
    setCheck2Preview(dealerObj.cheque_2_image);
    setCurrentapplicableVal(dealerObj.security_deposit_flag);
    setCurrentValue(dealerObj.file_upload_flag);
    setIsKycRequired(dealerObj.is_approved);
    setBusinessTitle({
      name: dealerObj.business_name,
      page: dealerObj.page_3,
    });
  }, [dealerObj]);

  const removeSelectedImage = (key) => {
    if (key === 41) {
      setAdharPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 55) {
      setCheckPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 56) {
      setNeftPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 13) {
      setCheck1Preview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 16) {
      setCheck2Preview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 14) {
      setGstPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 15) {
      setPanFirmPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 17) {
      setPanOwnerPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 1) {
      setShopPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 18) {
      setFertilizePreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 19) {
      setPesticidesPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 23) {
      setReturnItPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 24) {
      setBankStPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    } else if (key === 40) {
      setPrShipDeedPreview();
      setPopupImgPreview();
      setPreviewImgModal(!previewImgModal);
    }
  };

  const options = [
    { id: 1, name: 'Cheque' },
    { id: 2, name: 'NEFT/RTGS' },
  ];

  const functCommonUpload = (fileVal, setBinaryImg, setOriginalImg) => {
    setBinaryImg(Array.from(fileVal));
    let images = [];
    for (let i = 0; i < fileVal.length; i++) {
      images.push({
        filename: fileVal[i].name,
        url: URL.createObjectURL(fileVal[i]),
        type: fileVal[i].type,
      });
    }
    setOriginalImg(images);
    setUploadModal(!uploadModal);
  };

  const handleCommonUpload = (e, key) => {
    setDocKey(key);
    if (key === 4) {
      functCommonUpload(e.target.files, setAdharBinaryImg, setAdharImg);
      // setAdharBinaryImg(Array.from(e.target.files));
      // let images = [];
      // for (let i = 0; i < e.target.files.length; i++) {
      //   images.push({ filename: e.target.files[i].name, url: URL.createObjectURL(e.target.files[i]), type: e.target.files[i].type });
      // }
      // setAdharImg(images);
      // setUploadModal(!uploadModal);
    } else if (key === 10) {
      functCommonUpload(e.target.files, setCheckBinaryImg, setCheckImg);
    } else if (key === 11) {
      functCommonUpload(e.target.files, setNeftBinaryImg, setNeftImg);
    } else if (key === 13) {
      functCommonUpload(e.target.files, setCheck1BinaryImg, setCheck1Img);
    } else if (key === 16) {
      functCommonUpload(e.target.files, setCheck2BinaryImg, setCheck2Img);
    } else if (key === 2) {
      functCommonUpload(e.target.files, setGstBinaryImg, setGstImg);
    } else if (key === 15) {
      functCommonUpload(e.target.files, setPanFirmBinaryImg, setPanFirmImg);
    } else if (key === 3) {
      functCommonUpload(e.target.files, setPanOwnerBinaryImg, setPanOwnerImg);
    } else if (key === 1) {
      functCommonUpload(e.target.files, setShopBinaryImg, setShopImg);
    } else if (key === 5) {
      functCommonUpload(e.target.files, setFertilizeBinaryImg, setFertilizeImg);
    } else if (key === 6) {
      functCommonUpload(
        e.target.files,
        setPesticidesBinaryImg,
        setPesticidesImg,
      );
    } else if (key === 7) {
      functCommonUpload(e.target.files, setReturnItBinaryImg, setReturnItImg);
    } else if (key === 14) {
      functCommonUpload(e.target.files, setBankStBinaryImg, setBankStImg);
    } else if (key === 8) {
      functCommonUpload(
        e.target.files,
        setPrShipDeedBinaryImg,
        setPrShipDeedImg,
      );
    }
  };

  const functCommonAddMoreDoc = (
    fileVal,
    binaryImgArr,
    originalArr,
    setBinaryImg,
    setOriginalImg,
  ) => {
    let newBinaryArr = binaryImgArr.concat(Array.from(fileVal));
    setBinaryImg(newBinaryArr);
    let moreImg = [];
    for (let i = 0; i < fileVal.length; i++) {
      moreImg.push({
        filename: fileVal[i].name,
        url: URL.createObjectURL(fileVal[i]),
        type: fileVal[i].type,
      });
    }
    let newDocArr = originalArr.concat(moreImg);
    setOriginalImg(newDocArr);
  };

  const handleChangeMoreDoc = (e, key) => {
    if (key === 4) {
      functCommonAddMoreDoc(
        e.target.files,
        adharBinaryImg,
        adharImg,
        setAdharBinaryImg,
        setAdharImg,
      );
      // let newBinaryArr = adharBinaryImg.concat(Array.from(e.target.files))
      // setAdharBinaryImg(newBinaryArr);
      // let moreImg = [];
      // for (let i = 0; i < e.target.files.length; i++) {
      //   moreImg.push({ filename: e.target.files[i].name, url: URL.createObjectURL(e.target.files[i]), type: e.target.files[i].type });
      // }
      // let newDocArr = adharImg.concat(moreImg);
      // setAdharImg(newDocArr);
    } else if (key === 10) {
      functCommonAddMoreDoc(
        e.target.files,
        checkBinaryImg,
        checkImg,
        setCheckBinaryImg,
        setCheckImg,
      );
    } else if (key === 11) {
      functCommonAddMoreDoc(
        e.target.files,
        neftBinaryImg,
        neftImg,
        setNeftBinaryImg,
        setNeftImg,
      );
    } else if (key === 13) {
      functCommonAddMoreDoc(
        e.target.files,
        check1BinaryImg,
        check1Img,
        setCheck1BinaryImg,
        setCheck1Img,
      );
    } else if (key === 16) {
      functCommonAddMoreDoc(
        e.target.files,
        check2BinaryImg,
        check2Img,
        setCheck2BinaryImg,
        setCheck2Img,
      );
    } else if (key === 2) {
      functCommonAddMoreDoc(
        e.target.files,
        gstBinaryImg,
        gstImg,
        setGstBinaryImg,
        setGstImg,
      );
    } else if (key === 15) {
      functCommonAddMoreDoc(
        e.target.files,
        panFirmBinaryImg,
        panFirmImg,
        setPanFirmBinaryImg,
        setPanFirmImg,
      );
    } else if (key === 3) {
      functCommonAddMoreDoc(
        e.target.files,
        panOwnerBinaryImg,
        panOwnerImg,
        setPanOwnerBinaryImg,
        setPanOwnerImg,
      );
    } else if (key === 1) {
      functCommonAddMoreDoc(
        e.target.files,
        shopBinaryImg,
        shopImg,
        setShopBinaryImg,
        setShopImg,
      );
    } else if (key === 5) {
      functCommonAddMoreDoc(
        e.target.files,
        fertilizeBinaryImg,
        fertilizeImg,
        setFertilizeBinaryImg,
        setFertilizeImg,
      );
    } else if (key === 6) {
      functCommonAddMoreDoc(
        e.target.files,
        pesticidesBinaryImg,
        pesticidesImg,
        setPesticidesBinaryImg,
        setPesticidesImg,
      );
    } else if (key === 7) {
      functCommonAddMoreDoc(
        e.target.files,
        returnItBinaryImg,
        returnItImg,
        setReturnItBinaryImg,
        setReturnItImg,
      );
    } else if (key === 14) {
      functCommonAddMoreDoc(
        e.target.files,
        bankStBinaryImg,
        bankStImg,
        setBankStBinaryImg,
        setBankStImg,
      );
    } else if (key === 8) {
      functCommonAddMoreDoc(
        e.target.files,
        prShipDeedBinaryImg,
        prShipDeedImg,
        setPrShipDeedBinaryImg,
        setPrShipDeedImg,
      );
    }
  };

  const commonDeleteDoc = (
    index,
    binaryImgArr,
    originalArr,
    setBinaryImg,
    setOriginalImg,
  ) => {
    let filterBinaryArr = [...binaryImgArr];
    filterBinaryArr.splice(index, 1);
    setBinaryImg(filterBinaryArr);

    let filterOriginalArr = [...originalArr];
    filterOriginalArr.splice(index, 1);
    setOriginalImg(filterOriginalArr);
  };

  const handleDeleteDoc = (key, index) => {
    if (key === 4) {
      commonDeleteDoc(
        index,
        adharBinaryImg,
        adharImg,
        setAdharBinaryImg,
        setAdharImg,
      );
    } else if (key === 10) {
      commonDeleteDoc(
        index,
        checkBinaryImg,
        checkImg,
        setCheckBinaryImg,
        setCheckImg,
      );
    } else if (key === 11) {
      commonDeleteDoc(
        index,
        neftBinaryImg,
        neftImg,
        setNeftBinaryImg,
        setNeftImg,
      );
    } else if (key === 13) {
      commonDeleteDoc(
        index,
        check1BinaryImg,
        check1Img,
        setCheck1BinaryImg,
        setCheck1Img,
      );
    } else if (key === 16) {
      commonDeleteDoc(
        index,
        check2BinaryImg,
        check2Img,
        setCheck2BinaryImg,
        setCheck2Img,
      );
    } else if (key === 2) {
      commonDeleteDoc(index, gstBinaryImg, gstImg, setGstBinaryImg, setGstImg);
    } else if (key === 15) {
      commonDeleteDoc(
        index,
        panFirmBinaryImg,
        panFirmImg,
        setPanFirmBinaryImg,
        setPanFirmImg,
      );
    } else if (key === 3) {
      commonDeleteDoc(
        index,
        panOwnerBinaryImg,
        panOwnerImg,
        setPanOwnerBinaryImg,
        setPanOwnerImg,
      );
    } else if (key === 1) {
      commonDeleteDoc(
        index,
        shopBinaryImg,
        shopImg,
        setShopBinaryImg,
        setShopImg,
      );
    } else if (key === 5) {
      commonDeleteDoc(
        index,
        fertilizeBinaryImg,
        fertilizeImg,
        setFertilizeBinaryImg,
        setFertilizeImg,
      );
    } else if (key === 6) {
      commonDeleteDoc(
        index,
        pesticidesBinaryImg,
        pesticidesImg,
        setPesticidesBinaryImg,
        setPesticidesImg,
      );
    } else if (key === 7) {
      commonDeleteDoc(
        index,
        returnItBinaryImg,
        returnItImg,
        setReturnItBinaryImg,
        setReturnItImg,
      );
    } else if (key === 14) {
      commonDeleteDoc(
        index,
        bankStBinaryImg,
        bankStImg,
        setBankStBinaryImg,
        setBankStImg,
      );
    } else if (key === 8) {
      commonDeleteDoc(
        index,
        prShipDeedBinaryImg,
        prShipDeedImg,
        setPrShipDeedBinaryImg,
        setPrShipDeedImg,
      );
    }
  };

  const functDocUpload = (binaryImgArr, originalArr, previewImgSet) => {
    let pdfDocIndex = originalArr.findIndex(
      (e) => e.type === 'application/pdf',
    );
    let ImgDocIndex = originalArr.findIndex(
      (e) => e.type === 'image/jpeg' || e.type === 'image/png',
    );

    if (pdfDocIndex > -1 && ImgDocIndex > -1) {
      ModalService.openAlert('', messages.COMMON.EITHER_PDF_IMAGE, 'error');
    } else if (
      pdfDocIndex > -1 &&
      ImgDocIndex === -1 &&
      originalArr &&
      originalArr.length > 1
    ) {
      ModalService.openAlert('', messages.COMMON.MULTIPLE_PDF, 'error');
    } else {
      let formData = new FormData();
      for (let i = 0; i < binaryImgArr.length; i++) {
        formData.append('files', binaryImgArr[i]);
      }
      formData.append('ownerimage', false);
      setIsloading(false);
      setIsModalLoading(true);
      dealerDocumentUpload((res) => {
        const { success, data, message, error } = res;
        if (success === true) {
          previewImgSet(data.imageUrl);
          setUploadModal(!uploadModal);
          ModalService.openAlert('', message, 'success');
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, formData);
    }
  };

  const handleUploadDoc = (key) => {
    if (key === 4) {
      functDocUpload(adharBinaryImg, adharImg, setAdharPreview);
      // let pdfDocIndex = adharImg.findIndex(e => e.type === 'application/pdf')
      // let ImgDocIndex = adharImg.findIndex(e => e.type === 'image/jpeg' || e.type === 'image/png')

      // if (pdfDocIndex > -1 && ImgDocIndex > -1) {
      //   ModalService.openAlert('', "please select either image or pdf", 'error');
      // } else if (pdfDocIndex > -1 && ImgDocIndex === -1 && adharImg && adharImg.length > 1) {
      //   ModalService.openAlert('', "only 1 pdf allow to upload", 'error');
      // } else {
      //   let formData = new FormData();
      //   for (let i = 0; i < adharBinaryImg.length; i++) {
      //     formData.append('files', adharBinaryImg[i]);
      //   }
      //   setIsloading(false);
      //   setIsModalLoading(true);
      //   dealerDocumentUpload((res) => {
      //     const { success, data, error } = res;
      //     if (success === true) {
      //       setAdharPreview(data.imageUrl);
      //       setUploadModal(!uploadModal);
      //     } else if (success === false || success === 'undefined') {
      //       ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      //     }
      //     setIsloading(false);
      //     setIsModalLoading(false);
      //   }, formData);
      // }
    } else if (key === 10) {
      functDocUpload(checkBinaryImg, checkImg, setCheckPreview);
    } else if (key === 11) {
      functDocUpload(neftBinaryImg, neftImg, setNeftPreview);
    } else if (key === 13) {
      functDocUpload(check1BinaryImg, check1Img, setCheck1Preview);
    } else if (key === 16) {
      functDocUpload(check2BinaryImg, check2Img, setCheck2Preview);
    } else if (key === 2) {
      functDocUpload(gstBinaryImg, gstImg, setGstPreview);
    } else if (key === 15) {
      functDocUpload(panFirmBinaryImg, panFirmImg, setPanFirmPreview);
    } else if (key === 3) {
      functDocUpload(panOwnerBinaryImg, panOwnerImg, setPanOwnerPreview);
    } else if (key === 1) {
      functDocUpload(shopBinaryImg, shopImg, setShopPreview);
    } else if (key === 5) {
      functDocUpload(fertilizeBinaryImg, fertilizeImg, setFertilizePreview);
    } else if (key === 6) {
      functDocUpload(pesticidesBinaryImg, pesticidesImg, setPesticidesPreview);
    } else if (key === 7) {
      functDocUpload(returnItBinaryImg, returnItImg, setReturnItPreview);
    } else if (key === 14) {
      functDocUpload(bankStBinaryImg, bankStImg, setBankStPreview);
    } else if (key === 8) {
      functDocUpload(prShipDeedBinaryImg, prShipDeedImg, setPrShipDeedPreview);
    }
  };

  const handleChange = (e, key) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (key === 7) {
      setChequeSelection(e.target.value);
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let payload = {
      id: userId,
      bank_name: formValues.bankName,
      account_number: formValues.accountNumber,
      ifsc_code: formValues.ifscNeftRtgsCode,
      sigining_authority_person_name: formValues.authorityBankName,
      shop_act_no: formValues.shopActNumber,
      shop_act_no_file: shopPreview ? shopPreview : null,
      gst_no: formValues.gstNumber,
      gst_no_file: gstPreview ? gstPreview : null,
      pan_no: formValues.panNumber,
      pan_no_file: panOwnerPreview ? panOwnerPreview : null,
      aadhar_no: formValues.adharNumber,
      aadhar_no_file: adharPreview ? adharPreview : null,

      fertilizer_lic_no: formValues.wholeSaleLicenseNumber || null,
      fertilizer_lic_no_file: fertilizePreview ? fertilizePreview : '',
      fertilizer_lic_valid_date: formValues.licenseValidDate || '',

      pesticides_lic_no: formValues.pesticideLicenseNumber || null,
      pesticides_lic_no_file: pesticidesPreview ? pesticidesPreview : '',
      pesticides_lic_valid_date: formValues.pesticideLicenseValidDate || '',

      it_return_file:
        currentRadioValue === 'lastYearItReturn'
          ? returnItPreview
            ? returnItPreview
            : null
          : null,
      last_six_month_bank_statement:
        currentRadioValue === 'lastSixMonthBankStmnt'
          ? bankStPreview
            ? bankStPreview
            : null
          : null,
      partnership_deed_file: prShipDeedPreview ? prShipDeedPreview : null,
      wholesale_license_file: null,
      bank_address: formValues.branchAddress,
      bank_limit: formValues.cCLimit,
      cheque_bank_name:
        formValues.modeOfPayment === 'Cheque'
          ? formValues.chequeBankName
          : null,
      cheque_date:
        formValues.modeOfPayment === 'Cheque' ? formValues.chequeDate : null,
      cheque_image:
        formValues.modeOfPayment === 'Cheque'
          ? checkPreview
            ? checkPreview
            : null
          : null,
      cheque_number:
        formValues.modeOfPayment === 'Cheque' ? formValues.cheque : null,
      neft_rtgs_date:
        formValues.modeOfPayment === 'NEFT/RTGS'
          ? formValues.neftRtgsDate
          : null,
      neft_rtgs_reciept:
        formValues.modeOfPayment === 'NEFT/RTGS'
          ? neftPreview
            ? neftPreview
            : null
          : null,
      neft_rtgs_ref_number:
        formValues.modeOfPayment === 'NEFT/RTGS'
          ? formValues.neftRtgsRefNo
          : null,
      payment_mode: formValues.modeOfPayment,
      seeds_license_number: '',
      seeds_license_date: '',
      seeds_license_upload: null,
      security_deposit: formValues.amount,
      branch_name: formValues.brnachName,
      firm_pan_file: panFirmPreview ? panFirmPreview : null,
      firm_pan_no: formValues.firmPanNumber,
      cheque_number_1: formValues.chequeOneNumber,
      cheque_number_2: formValues.chequeTwoNumber,
      security_deposit_flag: currentapplicableVal,
      security_bank_name: formValues.securityBankName,
      cheque_1_image: check1Preview ? check1Preview : null,
      cheque_2_image: check2Preview ? check2Preview : null,
      file_upload_flag: currentRadioValue,
      page_3: 1,
    };
    setIsloading(true);
    if (
      !(
        formValues.wholeSaleLicenseNumber ||
        fertilizePreview ||
        formValues.wholeSaleLicenseNumber ||
        formValues.pesticideLicenseNumber ||
        pesticidesPreview ||
        formValues.pesticideLicenseValidDate
      )
    ) {
      ModalService.openAlert(
        '',
        'Please fill up fertilizers license no. and its related image and date or fill up pesticides license no and its related image and date !',
        'warning',
      );
      setIsloading(false);
    } else {
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleSaveAsDraft = (evt) => {
    evt.preventDefault();
    let payload = {
      id: userId,
      bank_name: formValues.bankName,
      account_number: formValues.accountNumber,
      ifsc_code: formValues.ifscNeftRtgsCode,
      sigining_authority_person_name: formValues.authorityBankName,
      shop_act_no: formValues.shopActNumber,
      shop_act_no_file: shopPreview ? shopPreview : null,
      gst_no: formValues.gstNumber,
      gst_no_file: gstPreview ? gstPreview : null,
      pan_no: formValues.panNumber,
      pan_no_file: panOwnerPreview ? panOwnerPreview : null,
      aadhar_no: formValues.adharNumber,
      aadhar_no_file: adharPreview ? adharPreview : null,

      fertilizer_lic_no: formValues.wholeSaleLicenseNumber || null,
      fertilizer_lic_no_file: fertilizePreview ? fertilizePreview : '',
      fertilizer_lic_valid_date: formValues.licenseValidDate || '',

      pesticides_lic_no: formValues.pesticideLicenseNumber || null,
      pesticides_lic_no_file: pesticidesPreview ? pesticidesPreview : '',
      pesticides_lic_valid_date: formValues.pesticideLicenseValidDate || '',

      it_return_file:
        currentRadioValue === 'lastYearItReturn'
          ? returnItPreview
            ? returnItPreview
            : null
          : null,
      last_six_month_bank_statement:
        currentRadioValue === 'lastSixMonthBankStmnt'
          ? bankStPreview
            ? bankStPreview
            : null
          : null,
      partnership_deed_file: prShipDeedPreview ? prShipDeedPreview : null,
      wholesale_license_file: null,
      bank_address: formValues.branchAddress,
      bank_limit: formValues.cCLimit,
      cheque_bank_name:
        formValues.modeOfPayment === 'Cheque'
          ? formValues.chequeBankName
          : null,
      cheque_date:
        formValues.modeOfPayment === 'Cheque' ? formValues.chequeDate : null,
      cheque_image:
        formValues.modeOfPayment === 'Cheque'
          ? checkPreview
            ? checkPreview
            : null
          : null,
      cheque_number:
        formValues.modeOfPayment === 'Cheque' ? formValues.cheque : null,
      neft_rtgs_date:
        formValues.modeOfPayment === 'NEFT/RTGS'
          ? formValues.neftRtgsDate
          : null,
      neft_rtgs_reciept:
        formValues.modeOfPayment === 'NEFT/RTGS'
          ? neftPreview
            ? neftPreview
            : null
          : null,
      neft_rtgs_ref_number:
        formValues.modeOfPayment === 'NEFT/RTGS'
          ? formValues.neftRtgsRefNo
          : null,
      payment_mode: formValues.modeOfPayment,
      seeds_license_number: '',
      seeds_license_date: '',
      seeds_license_upload: null,
      security_deposit: formValues.amount,
      branch_name: formValues.brnachName,
      firm_pan_file: panFirmPreview ? panFirmPreview : null,
      firm_pan_no: formValues.firmPanNumber,
      cheque_number_1: formValues.chequeOneNumber,
      cheque_number_2: formValues.chequeTwoNumber,
      security_deposit_flag: currentapplicableVal,
      security_bank_name: formValues.securityBankName,
      cheque_1_image: check1Preview ? check1Preview : null,
      cheque_2_image: check2Preview ? check2Preview : null,
      file_upload_flag: currentRadioValue,
      page_3: 0,
    };

    if (payload) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setTimeout(() => {
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          }, 3000);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
    }
  };

  const togglePreviewImgModal = (val, title, key) => {
    setImageKey(key);
    if (key) {
      setPopupImgPreview(val);
      setTitle(title);
    }
    setPreviewImgModal(!previewImgModal);
  };

  const handleBack = () => {
    const lastRoute = Storage.backBreadcrumbsButton();
    navigate(lastRoute.url, { replace: true });
  };

  const uploadModalData = () => {
    let uploadData = [];
    if (docKey === 4) {
      uploadData = adharImg;
    } else if (docKey === 10) {
      uploadData = checkImg;
    } else if (docKey === 11) {
      uploadData = neftImg;
    } else if (docKey === 13) {
      uploadData = check1Img;
    } else if (docKey === 16) {
      uploadData = check2Img;
    } else if (docKey === 2) {
      uploadData = gstImg;
    } else if (docKey === 15) {
      uploadData = panFirmImg;
    } else if (docKey === 3) {
      uploadData = panOwnerImg;
    } else if (docKey === 1) {
      uploadData = shopImg;
    } else if (docKey === 5) {
      uploadData = fertilizeImg;
    } else if (docKey === 6) {
      uploadData = pesticidesImg;
    } else if (docKey === 7) {
      uploadData = returnItImg;
    } else if (docKey === 14) {
      uploadData = bankStImg;
    } else if (docKey === 8) {
      uploadData = prShipDeedImg;
    }
    return uploadData;
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="AdvanceBusinessDetails">
              {isLoading && <CustomSpinner />}
              <div className="pageWrapper">
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className="pageheader">
                        <DashBoardTitle
                          dashBorardName={
                            businessTitle.page === 1
                              ? businessTitle.name
                              : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title="Advance Business Details" />
                    </Col>
                  </Row>
                  <div className="advanceBusinessBlock">
                    <div className="advanceBusinessBlockInner">
                      <Row>
                        <Col xs={12}>
                          <div className="dealerRegBlocktitle text-center noprint">
                            Advance Business Details
                          </div>
                        </Col>
                      </Row>
                      <Form onSubmit={handleSubmit}>
                        <div className="innerArea">
                          <Row>
                            <Col xs={12}>
                              <div className="dealerRegBlocktitleInner noprint">
                                Bank Details
                              </div>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Current A/C No.<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  type="text"
                                  required
                                  autoComplete="off"
                                  name="accountNumber"
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={
                                    formValues.accountNumber !== null
                                      ? formValues.accountNumber
                                      : ''
                                  }
                                  onChange={handleChange}
                                  placeholder="Type Here"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  IFSC/NEFT/RTGS Code<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  type="text"
                                  required
                                  autoComplete="off"
                                  name="ifscNeftRtgsCode"
                                  value={
                                    formValues.ifscNeftRtgsCode !== null
                                      ? formValues.ifscNeftRtgsCode
                                      : ''
                                  }
                                  onChange={handleChange}
                                  placeholder="Type Here"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Bank Name<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  type="text"
                                  required
                                  autoComplete="off"
                                  name="bankName"
                                  value={
                                    formValues.bankName !== null
                                      ? formValues.bankName
                                      : ''
                                  }
                                  onChange={handleChange}
                                  placeholder="Type Here"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Branch Name<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  type="text"
                                  required
                                  onKeyPress={(event) => {
                                    if (
                                      /^(?=.{0,20}$)(?![_.])(?!.*[_.]{2})[0-9._]+(?<![_.])$/.test(
                                        event.key,
                                      )
                                    ) {
                                      event.preventDefault();
                                    }
                                  }}
                                  autoComplete="off"
                                  name="brnachName"
                                  value={
                                    formValues.brnachName !== null
                                      ? formValues.brnachName
                                      : ''
                                  }
                                  onChange={handleChange}
                                  placeholder="Type Here"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Signing Authority Name
                                  <span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  type="text"
                                  required
                                  autoComplete="off"
                                  name="authorityBankName"
                                  value={
                                    formValues.authorityBankName !== null
                                      ? formValues.authorityBankName
                                      : ''
                                  }
                                  onKeyPress={(event) => {
                                    if (
                                      /^(?=.{0,20}$)(?![_.])(?!.*[_.]{2})[0-9._]+(?<![_.])$/.test(
                                        event.key,
                                      )
                                    ) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={handleChange}
                                  placeholder="Type Here"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  CC Limit of Bank
                                  <span className="required">*</span>
                                </Label>
                                <NumericFormat
                                  className="common-input"
                                  type="text"
                                  required
                                  thousandSeparator={true}
                                  autoComplete="off"
                                  thousandsGroupStyle="lakh"
                                  prefix="₹"
                                  name="cCLimit"
                                  onKeyPress={(event) => {
                                    if (!/^\d{0,4}(\.\d{0,4})?$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={
                                    formValues.cCLimit !== null
                                      ? formValues.cCLimit
                                      : ''
                                  }
                                  onChange={handleChange}
                                  placeholder="Type Here"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Branch Address<span className="required">*</span>
                                </Label>
                                <Input
                                  type="textarea"
                                  name="branchAddress"
                                  value={
                                    formValues.branchAddress !== null
                                      ? formValues.branchAddress
                                      : ''
                                  }
                                  className="address-area w-100"
                                  required
                                  onChange={(e) => handleChange(e, 10)}
                                  rows="5"
                                ></Input>
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea">
                          <Row>
                            <Col xs={12}>
                              <div className="dealerRegBlocktitleInner noprint">
                                Security Deposit
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4} className="align-self-center">
                              <div className="d-flex flex-wrap align-items-center">
                                <FormGroup
                                  className="d-flex align-items-center"
                                  style={{ marginRight: '20px' }}
                                >
                                  <Input
                                    type="radio"
                                    className="ml-0 mt-0"
                                    onChange={(e) =>
                                      setCurrentapplicableVal(e.target.value)
                                    }
                                    name="securityDepositeStatus"
                                    required
                                    checked={currentapplicableVal === 'Applicable'}
                                    value={'Applicable'}
                                  />
                                  <Label className="common-input-label mb-0 ml-4">
                                    Applicable
                                  </Label>
                                </FormGroup>
                                <FormGroup className="d-flex align-items-center">
                                  <Input
                                    type="radio"
                                    className="ml-0 mt-0"
                                    onChange={(e) =>
                                      setCurrentapplicableVal(e.target.value)
                                    }
                                    name="securityDepositeStatus"
                                    required
                                    checked={currentapplicableVal === 'Non Applicable'}
                                    value={'Non Applicable'}
                                  />
                                  <Label className="common-input-label mb-0 ml-4">
                                    Not Applicable
                                  </Label>
                                </FormGroup>
                              </div>
                            </Col>
                            {currentapplicableVal === 'Applicable' && (
                              <>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      Amount<span className="required">*</span>
                                    </Label>
                                    <br />
                                    <NumericFormat
                                      className="common-input"
                                      type="text"
                                      required
                                      prefix="₹"
                                      autoComplete="off"
                                      thousandsGroupStyle="lakh"
                                      name="amount"
                                      value={
                                        formValues.amount !== null
                                          ? formValues.amount
                                          : ''
                                      }
                                      onKeyPress={(event) => {
                                        if (!/^\d{0,4}(\.\d{0,4})?$/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      style={{ paddingLeft: '10px' }}
                                      thousandSeparator={true}
                                      onChange={handleChange}
                                      placeholder="Type Here"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label className="common-input-label">
                                      Mode of Payment<span className="required">*</span>
                                    </Label>
                                    <div className="select-wrapper">
                                      <Input
                                        type="select"
                                        value={
                                          formValues.modeOfPayment !== null
                                            ? formValues.modeOfPayment
                                            : ''
                                        }
                                        id="select"
                                        required
                                        name="modeOfPayment"
                                        onChange={(e) => handleChange(e, 7)}
                                      >
                                        <option value={''}>Select</option>
                                        {options.length > 0 &&
                                          options.map((cheque, index) => {
                                            return (
                                              <option key={index} value={cheque.name}>
                                                {cheque.name}
                                              </option>
                                            );
                                          })}
                                      </Input>
                                    </div>
                                  </FormGroup>
                                </Col>
                              </>
                            )}
                          </Row>
                          {currentapplicableVal === 'Applicable' &&
                            (chequeSelection === 'Cheque' ||
                              formValues.modeOfPayment === 'Cheque') ? (
                            <Row>
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="common-input-label">
                                    Bank Name<span className="required">*</span>
                                  </Label>
                                  <Input
                                    className="common-input"
                                    type="text"
                                    required
                                    autoComplete="off"
                                    name="chequeBankName"
                                    value={
                                      formValues.chequeBankName !== null
                                        ? formValues.chequeBankName
                                        : ''
                                    }
                                    onChange={handleChange}
                                    placeholder="Type Here"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="common-input-label">
                                    Cheque No.<span className="required">*</span>
                                  </Label>
                                  <Input
                                    className="common-input"
                                    type="text"
                                    required
                                    autoComplete="off"
                                    name="cheque"
                                    value={
                                      formValues.cheque !== null
                                        ? formValues.cheque
                                        : ''
                                    }
                                    onChange={handleChange}
                                    placeholder="Type Here"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} className="business-group">
                                <FormGroup>
                                  <Label className="common-input-label">
                                    Cheque Date<span className="required">*</span>
                                  </Label>
                                  <Input
                                    type="date"
                                    className="calendar-input"
                                    onChange={handleChange}
                                    maxLength="4"
                                    max={'9999-12-31'}
                                    pattern="[1-9][0-9]{3}"
                                    min={moment(new Date()).format('YYYY-MM-DD')}
                                    value={
                                      formValues.chequeDate !== null
                                        ? formValues.chequeDate
                                        : null
                                    }
                                    required={!formValues.chequeDate}
                                    name="chequeDate"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <div className="uploadArea">
                                  <div className="d-flex align-items-center">
                                    <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                      <Label className="common-input-label mb-0">
                                        Upload Cheque Image
                                        <span className="required">*</span>
                                      </Label>
                                      {!checkPreview ? (
                                        <Label className="uploadLabel">
                                          <Input
                                            type="file"
                                            required={!checkPreview}
                                            name="chequeUpload"
                                            onChange={(e) => {
                                              handleCommonUpload(e, 10);
                                            }}
                                            accept="image/*, application/pdf"
                                            multiple
                                          />
                                          <img
                                            className="uploadImg"
                                            src={uploadImg}
                                            alt=""
                                          />
                                        </Label>
                                      ) : (
                                        <img
                                          src={previewImg}
                                          alt=""
                                          className="preViewImg"
                                          onClick={() =>
                                            togglePreviewImgModal(
                                              checkPreview,
                                              'Cheque Image',
                                              55,
                                            )
                                          }
                                        />
                                      )}
                                    </FormGroup>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          ) : null}
                          {/* NEFT Selection */}
                          {currentapplicableVal === 'Applicable' &&
                            (chequeSelection === 'NEFT/RTGS' ||
                              formValues.modeOfPayment === 'NEFT/RTGS') ? (
                            <Row>
                              <Col md={4}>
                                <FormGroup>
                                  <Label className="common-input-label">
                                    NEFT/RTGS Reference No.
                                    <span className="required">*</span>
                                  </Label>
                                  <Input
                                    className="common-input"
                                    type="text"
                                    required
                                    value={
                                      formValues.neftRtgsRefNo !== null
                                        ? formValues.neftRtgsRefNo
                                        : ''
                                    }
                                    autoComplete="off"
                                    name="neftRtgsRefNo"
                                    onChange={handleChange}
                                    placeholder="Type Here"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} className="business-group">
                                <FormGroup>
                                  <Label className="common-input-label">
                                    Date
                                    <span className="required">*</span>
                                  </Label>
                                  <Input
                                    type="date"
                                    className="calendar-input"
                                    onChange={handleChange}
                                    min={moment(new Date()).format('YYYY-MM-DD')}
                                    value={
                                      formValues.neftRtgsDate !== null
                                        ? formValues.neftRtgsDate
                                        : null
                                    }
                                    required={!formValues.neftRtgsDate}
                                    maxLength="4"
                                    max={'9999-12-31'}
                                    pattern="[1-9][0-9]{3}"
                                    name="neftRtgsDate"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} className="align-self-center">
                                <div className="uploadArea">
                                  <div className="d-flex align-items-center">
                                    <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                      <Label className="common-input-label mb-0">
                                        Upload Reciept
                                        <span className="required">*</span>
                                      </Label>
                                      {!neftPreview ? (
                                        <Label className="uploadLabel">
                                          <Input
                                            type="file"
                                            required={!neftPreview}
                                            name="neftRtgsUpload"
                                            onChange={(e) => {
                                              handleCommonUpload(e, 11);
                                            }}
                                            accept="image/*, application/pdf"
                                            multiple
                                          />
                                          <img
                                            className="uploadImg"
                                            src={uploadImg}
                                            alt=""
                                          />
                                        </Label>
                                      ) : (
                                        <img
                                          src={previewImg}
                                          alt=""
                                          className="preViewImg"
                                          onClick={() =>
                                            togglePreviewImgModal(
                                              neftPreview,
                                              'Reciept',
                                              56,
                                            )
                                          }
                                        />
                                      )}
                                    </FormGroup>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          ) : null}
                        </div>
                        <div className="innerArea">
                          <Row>
                            <Col xs={12}>
                              <div className="dealerRegBlocktitleInner noprint">
                                Additional Security Cheque
                              </div>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Bank Name<span className="required">*</span>
                                </Label>
                                <Input
                                  className="common-input"
                                  type="text"
                                  required
                                  autoComplete="off"
                                  name="securityBankName"
                                  value={
                                    formValues.securityBankName !== null
                                      ? formValues.securityBankName
                                      : ''
                                  }
                                  onChange={handleChange}
                                  placeholder="Type Here"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Cheque 1 Number<span className="required">*</span>
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      required
                                      autoComplete="off"
                                      placeholder="Type Here"
                                      value={
                                        formValues.chequeOneNumber !== null
                                          ? formValues.chequeOneNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="chequeOneNumber"
                                    />
                                    {!check1Preview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          required={!check1Preview}
                                          name="chequeOneImage"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 13);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            check1Preview,
                                            'Cheque 1 Number',
                                            13,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Cheque 2 Number<span className="required">*</span>
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      required
                                      autoComplete="off"
                                      placeholder="Type Here"
                                      value={
                                        formValues.chequeTwoNumber !== null
                                          ? formValues.chequeTwoNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="chequeTwoNumber"
                                    />
                                    {!check2Preview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          required={!check2Preview}
                                          name="chequeTwoImage"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 16);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            check2Preview,
                                            'Cheque 2 Number',
                                            16,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea">
                          <Row>
                            <Col xs={12}>
                              <div className="dealerRegBlocktitleInner noprint">
                                Documents
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Enter Shop Act No.
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      // required
                                      autoComplete="off"
                                      placeholder="Type Here"
                                      value={
                                        formValues.shopActNumber !== null
                                          ? formValues.shopActNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="shopActNumber"
                                    />
                                    {!shopPreview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          // required={(!(shopPreview))}
                                          name="shopActDocumentUpload"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 1);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            shopPreview,
                                            'Enter Shop Act No.',
                                            1,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Enter GST No.<span className="required">*</span>
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      required
                                      minLength={15}
                                      maxLength={15}
                                      autoComplete="off"
                                      placeholder="Type Here"
                                      value={
                                        formValues.gstNumber !== null
                                          ? formValues.gstNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="gstNumber"
                                    />
                                    {!gstPreview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          required={!gstPreview}
                                          name="gstDocUpload"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 2);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            gstPreview,
                                            'Enter GST No.',
                                            14,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Enter PAN No. of Firm
                                  <span className="required">*</span>
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      required
                                      autoComplete="off"
                                      pattern=".{10,10}"
                                      maxLength="10"
                                      placeholder="Type Here"
                                      value={
                                        formValues.firmPanNumber !== null
                                          ? formValues.firmPanNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="firmPanNumber"
                                    />
                                    {!panFirmPreview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          required={!panFirmPreview}
                                          name="firmPanUpload"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 15);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            panFirmPreview,
                                            'Enter PAN No. of Firm',
                                            15,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Enter Aadhar No. Active Owner
                                  <span className="required">*</span>
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      required
                                      autoComplete="off"
                                      maxLength={12}
                                      minLength={12}
                                      placeholder="Type Here"
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      value={
                                        formValues.adharNumber !== null
                                          ? formValues.adharNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="adharNumber"
                                    />
                                    {!adharPreview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          required={!adharPreview}
                                          name="adharUpload"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 4);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            adharPreview,
                                            'Enter Aadhar No. of Proprietor',
                                            41,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Enter PAN No. of Active Owner
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      // required
                                      pattern=".{10,10}"
                                      maxLength="10"
                                      autoComplete="off"
                                      placeholder="Type Here"
                                      value={
                                        formValues.panNumber !== null
                                          ? formValues.panNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="panNumber"
                                    />
                                    {!panOwnerPreview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          // required={!panOwnerPreview}
                                          name="panUpload"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 3);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            panOwnerPreview,
                                            'Enter PAN No. of Proprietor / Partner',
                                            17,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea licenseArea noLine">
                          <Row>
                            <Col md={12}>
                              <p>(Note: Atleast one license is mandatory)</p>
                            </Col>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Enter Fertilizer License No.
                                  {/* <span className="required">*</span> */}
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      autoComplete="off"
                                      // required
                                      placeholder="Type Here"
                                      value={
                                        formValues.wholeSaleLicenseNumber !== null
                                          ? formValues.wholeSaleLicenseNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="wholeSaleLicenseNumber"
                                      required={
                                        fertilizePreview || formValues.licenseValidDate
                                      }
                                    />
                                    {!fertilizePreview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          // required={!fertilizePreview}
                                          name="wholsaleFetilizersLicenseUpload"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 5);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                          required={formValues.wholeSaleLicenseNumber}
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            fertilizePreview,
                                            'Enter Fertilizer License No',
                                            18,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Fertilizer License Valid Date
                                  {/* <span className="required">*</span> */}
                                </Label>
                                <Input
                                  type="date"
                                  className="calendar-input"
                                  value={
                                    formValues.licenseValidDate !== null
                                      ? formValues.licenseValidDate
                                      : ''
                                  }
                                  // required={!formValues.licenseValidDate}
                                  onChange={handleChange}
                                  min={moment(new Date()).format('YYYY-MM-DD')}
                                  maxLength="4"
                                  max={'9999-12-31'}
                                  pattern="[1-9][0-9]{3}"
                                  name="licenseValidDate"
                                  required={
                                    fertilizePreview ||
                                    formValues.wholeSaleLicenseNumber
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea licenseArea">
                          <Row>
                            <Col md={4}>
                              <div className="uploadArea">
                                <Label className="common-input-label">
                                  Enter Pesticides License No.
                                  {/* <span className="required">*</span> */}
                                </Label>
                                <div className="d-flex align-items-center">
                                  <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                    <Input
                                      type="text"
                                      autoComplete="off"
                                      // required
                                      placeholder="Type Here"
                                      value={
                                        formValues.pesticideLicenseNumber !== null
                                          ? formValues.pesticideLicenseNumber
                                          : ''
                                      }
                                      onChange={handleChange}
                                      className="common-input"
                                      name="pesticideLicenseNumber"
                                      required={
                                        pesticidesPreview ||
                                        formValues.pesticideLicenseValidDate
                                      }
                                    />
                                    {!pesticidesPreview ? (
                                      <Label className="uploadLabel">
                                        <Input
                                          type="file"
                                          // required={!pesticidesPreview}
                                          name="pesticideLicenseUpload"
                                          onChange={(e) => {
                                            handleCommonUpload(e, 6);
                                          }}
                                          accept="image/*, application/pdf"
                                          multiple
                                          required={formValues.pesticideLicenseNumber}
                                        />
                                        <img
                                          className="uploadImg"
                                          src={uploadImg}
                                          alt=""
                                        />
                                      </Label>
                                    ) : (
                                      <img
                                        src={previewImg}
                                        alt=""
                                        className="preViewImg"
                                        onClick={() =>
                                          togglePreviewImgModal(
                                            pesticidesPreview,
                                            'Enter Pesticides License No.',
                                            19,
                                          )
                                        }
                                      />
                                    )}
                                  </FormGroup>
                                </div>
                              </div>
                            </Col>
                            <Col md={4}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Pesticides License Valid Date
                                  {/* <span className="required">*</span> */}
                                </Label>
                                <Input
                                  type="date"
                                  value={
                                    formValues.pesticideLicenseValidDate !== null
                                      ? formValues.pesticideLicenseValidDate
                                      : ''
                                  }
                                  onChange={handleChange}
                                  min={moment(new Date()).format('YYYY-MM-DD')}
                                  // required={!formValues.pesticideLicenseValidDate}
                                  className="calendar-input"
                                  maxLength="4"
                                  max={'9999-12-31'}
                                  pattern="[1-9][0-9]{3}"
                                  name="pesticideLicenseValidDate"
                                  // onKeyDown={(e) => e.preventDefault()}
                                  required={
                                    pesticidesPreview ||
                                    formValues.pesticideLicenseNumber
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <div className="innerArea licenseArea">
                          <Row>
                            <Col md={12}>
                              <div className="returnArea">
                                <Row>
                                  <Col md={12} className="mb-2">
                                    (Note: Atleast one document is mandatory)
                                  </Col>
                                  <Col md={4}>
                                    <div className="uploadArea">
                                      <div className="d-flex align-items-center">
                                        <FormGroup className="mb-1 w-100 d-flex align-items-start">
                                          <Input
                                            type="radio"
                                            className="ml-0"
                                            onChange={(e) =>
                                              setCurrentValue(e.target.value)
                                            }
                                            name="document-upload"
                                            required
                                            checked={
                                              currentRadioValue === 'lastYearItReturn'
                                            }
                                            value={'lastYearItReturn'}
                                          />
                                          <Label className="common-input-label mb-0 ml-4">
                                            Upload Last Financial Year It Returns
                                            <span className="required">*</span>
                                          </Label>
                                          {currentRadioValue === 'lastYearItReturn' &&
                                            (!returnItPreview ? (
                                              <Label className="uploadLabel">
                                                <Input
                                                  type="file"
                                                  required={!returnItPreview}
                                                  name="itReturnFile"
                                                  onChange={(e) => {
                                                    handleCommonUpload(e, 7);
                                                  }}
                                                  accept="image/*, application/pdf"
                                                  multiple
                                                />
                                                <img
                                                  className="uploadImg"
                                                  src={uploadImg}
                                                  alt=""
                                                />
                                              </Label>
                                            ) : (
                                              <img
                                                src={previewImg}
                                                alt=""
                                                className="preViewImg"
                                                onClick={() =>
                                                  togglePreviewImgModal(
                                                    returnItPreview,
                                                    'Upload Last 3 Financial Year IT Return',
                                                    23,
                                                  )
                                                }
                                              />
                                            ))}
                                        </FormGroup>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={8}>
                                    <div className="uploadArea">
                                      <div className="d-flex align-items-center">
                                        <FormGroup className="mb-1 w-100 d-flex align-items-start">
                                          <Input
                                            type="radio"
                                            className="ml-0"
                                            required
                                            checked={
                                              currentRadioValue ===
                                              'lastSixMonthBankStmnt'
                                            }
                                            name="document-upload"
                                            onChange={(e) =>
                                              setCurrentValue(e.target.value)
                                            }
                                            value={'lastSixMonthBankStmnt'}
                                          />
                                          <Label className="common-input-label mb-0 ml-4">
                                            Upload Last 6 months Bank Statement
                                            <span className="required">*</span>
                                          </Label>
                                          {currentRadioValue ===
                                            'lastSixMonthBankStmnt' &&
                                            (!bankStPreview ? (
                                              <Label className="uploadLabel">
                                                <Input
                                                  type="file"
                                                  required={!bankStPreview}
                                                  name="sixMonthBnkStatment"
                                                  onChange={(e) => {
                                                    handleCommonUpload(e, 14);
                                                  }}
                                                  accept="image/*, application/pdf"
                                                  multiple
                                                />
                                                <img
                                                  className="uploadImg"
                                                  src={uploadImg}
                                                  alt=""
                                                />
                                              </Label>
                                            ) : (
                                              <img
                                                src={previewImg}
                                                alt=""
                                                className="preViewImg"
                                                onClick={() =>
                                                  togglePreviewImgModal(
                                                    bankStPreview,
                                                    'Upload Last 12 months Bank Statement',
                                                    24,
                                                  )
                                                }
                                              />
                                            ))}
                                        </FormGroup>
                                      </div>
                                      <div className="sixmonths-note commonNote">
                                        (Note:upload bank statement of only that bank
                                        account, which details are shared in the
                                        beginning)
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        {isDistributor ? (
                          <div className="innerArea licenseArea">
                            <Row>
                              <Col md={4}>
                                <div className="uploadArea">
                                  <div className="d-flex align-items-center">
                                    <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                      <Label className="common-input-label mb-0">
                                        {isDistributor === 'Partnership Firm'
                                          ? 'Upload Partnership Deed'
                                          : 'Upload M&A Copy'}
                                        <span className="required">*</span>
                                      </Label>
                                      {!prShipDeedPreview ? (
                                        <Label className="uploadLabel">
                                          <Input
                                            type="file"
                                            required={!prShipDeedPreview}
                                            name="partnershipUpload"
                                            onChange={(e) => {
                                              handleCommonUpload(e, 8);
                                            }}
                                            accept="image/*, application/pdf"
                                            multiple
                                          />
                                          <img
                                            className="uploadImg"
                                            src={uploadImg}
                                            alt=""
                                          />
                                        </Label>
                                      ) : (
                                        <img
                                          src={previewImg}
                                          alt=""
                                          className="preViewImg"
                                          onClick={() =>
                                            togglePreviewImgModal(
                                              prShipDeedPreview,
                                              'Upload Partnership Deed',
                                              40,
                                            )
                                          }
                                        />
                                      )}
                                    </FormGroup>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        ) : null}
                        <div className="innerArea">
                          <Row>
                            <Col xs={12}>
                              <div className="common-buttons d-flex flex-wrap align-items-center justify-content-center">
                                {isKycRequired ? (
                                  <CommonButton
                                    name={'Cancel'}
                                    btnClass={'btnSecondary'}
                                    type="button"
                                    onClick={handleBack}
                                  />
                                ) : (
                                  <CommonButton
                                    name={'Save as Draft'}
                                    btnClass={'btnSecondary'}
                                    type="button"
                                    onClick={handleSaveAsDraft}
                                  />
                                )}
                                <CommonButton
                                  name={'Submit'}
                                  btnClass={'btnPrimary'}
                                  type="submit"
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    </div>
                  </div>
                </Container>
              </div>

              {/* Upload Doc Modal */}
              <UploadModal
                isOpen={uploadModal}
                toggle={() => setUploadModal(!uploadModal)}
                isModalLoading={isModalLoading}
                modalData={uploadModalData()}
                uploadKey={docKey}
                handleChangeMoreDoc={handleChangeMoreDoc}
                handleDeleteDoc={handleDeleteDoc}
                handleUploadDoc={handleUploadDoc}
              />

              {/* Preview Doc Modal */}
              <Modal
                id="previewImgModal"
                isOpen={previewImgModal}
                toggle={togglePreviewImgModal}
                className="uploadDocModal"
                centered
              >
                <ModalBody className="pl-0 pr-0">
                  <Container>
                    <Row>
                      <Col xs={12}>
                        <div className="modalHeading">
                          <div className="title leftTitle">{title}</div>
                          <div className="closeButton">
                            <img
                              src={closeImg}
                              alt="close"
                              onClick={() => setPreviewImgModal(!previewImgModal)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} className="text-center">
                        <UploadDocPreview
                          isRemove={true}
                          uploadDocpath={popupImgPreview}
                          handleRemoveClick={() => removeSelectedImage(imageKey)}
                        />
                      </Col>
                    </Row>
                  </Container>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvanceBusinessDetails;
